




















































import { Component, Vue } from "vue-property-decorator";
import Search from "@/components/Search.vue";
import OfferList from "@/components/sale/list/OfferList.vue";
import { Action, Getter } from "vuex-class";
import { IOfferStatus, IOfferStatusListRequest } from "@/types/offerStatus";

@Component({
  components: { OfferList, Search },
})
export default class extends Vue {
  @Action("offerStatus/getList")
  public getStatuses!: (params: IOfferStatusListRequest) => Promise<void>;

  @Getter("offerStatus/list")
  public offerStatuses!: IOfferStatus[];

  public query = "";
  public status: number | string = "inprogress";

  public dialog = false;
  public member_id = 0;

  public created() {
    this.member_id = Number(this.$route.params.member_id);
    if (this.member_id) {
      this.status = 0;
    }
  }

  public async mounted() {
    await this.getStatuses({ per_page: 0 });
  }

  public search(): void {
    const target = this.$refs.offerList as OfferList;
    this.$nextTick(async () => {
      await target.getList();
    });
  }

  public get createPageRoute() {
    if (!this.member_id) {
      return { name: "SalesOfferCreate" };
    }

    return {
      name: "SalesMemberOfferCreate",
      params: { member_id: this.member_id },
    };
  }
}
